var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PopWrapper',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.$emit('cancel')},"confirm":_vm.confirm,"cancel":function($event){return _vm.$emit('cancel')}}},[_c('SelectRole',{ref:"selectRole",attrs:{"show-role":_vm.showRole,"bind-games":_vm.bindGames}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }